var _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.757,
    y1: 21.38,
    x2: 11.757,
    y2: 2.586
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.467,7.411h0c0-1.433-1.161-2.594-2.594-2.594h-3.692c-1.433,0-2.594,1.161-2.594,2.594v.612c0,1.028.607,1.958,1.547,2.373l5.619,2.48c.904.399,1.503,1.277,1.545,2.264l.055,1.306c.062,1.474-1.116,2.704-2.592,2.704h-4.119c-1.433,0-2.594-1.161-2.594-2.594v-.131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.2a47f04bf8f06f6bf55cdfaa57907465.svg";
export { ForwardRef as ReactComponent };